import { extendTheme, globalDarkTheme, unitTestTheme } from "@draftkings/arena-web";
import { accordionVariants } from "./variants/accortion";
import { backForwardControlsVariants } from "./variants/backForwardControls";
import { buttonVariants } from "./variants/button";
import { iconVariants } from "./variants/icon";
import { layoutVariants } from "./variants/layout";
import { segmentedControlVariants } from "./variants/segmentedControl";
import { tagLabelVariants } from "./variants/tagLabel";
import { textVariants } from "./variants/text";
const variants = {
    accordion: accordionVariants,
    backForwardControls: backForwardControlsVariants,
    button: buttonVariants,
    layout: layoutVariants,
    text: textVariants,
    segmentedControl: segmentedControlVariants,
    tagLabel: tagLabelVariants,
    icon: iconVariants,
};
const myBetsTheme = extendTheme(globalDarkTheme, { variants });
const myBetsUnitTestTheme = extendTheme(unitTestTheme, { variants });
export { myBetsTheme, myBetsUnitTestTheme };
//# sourceMappingURL=myBetsTheme.js.map